import React from "react";

const Loader = () => {
	return (
		<div className="flex items-center justify-center" style={{ width: "100%", height: "100dvh" }}>
			<span className="loader"></span>
		</div>
	);
};

export default Loader;
